<template lang="pug">
.before-after
  slot
  Icon(
    name="cart"
    size="25px"
  )
</template>

<script>
  import Icon from 'scripts/components/basic/Icon.vue';

  /**
   * @namespace BeforeAfter
   * @desc This component serves as a wrapper for the PDP Before + After section.
   *     In the future, this component will integrate with modal and lightbox
   *     components to display images in a lightbox carousel, which is why its
   *     being passed props that aren't used at the moment (3/8/21).
   *     SCSS is written in the global stylesheet to avoid layout shift during render.
   */
  export default {
    name: 'BeforeAfter',
    components:  {
      Icon
    },
    props: {
      heading: {
        type: String,
        default: 'Before & After Photos',
      },
      images: {
        type: Array,
        default: () => [],
      },
    },
  };
</script>
